import styled from 'styled-components';

export const TableStyled = styled.div`
  overflow-x: auto;
  background-color: white;
  padding: 10px 20px;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 20px 0 0 0;
  }

  .table {
    display: table;
    width: 100%;
    border-collapse: collapse;

    & .t-head {
      & .t-head-row {
        color: ${({ theme }) => theme.colors.primary};
        font-weight: 500;
        font-size: 12px;
        line-height: 14.52px;
        text-align: left;

        @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
          font-size: 14px;
          line-height: 25px;
        }
        @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
          font-size: 16px;
          line-height: 25px;
        }

        & .table-th {
          z-index: 0;
          padding-bottom: 10px;
          padding-right: 20px;

          @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
            padding-left: 20px;
            padding-right: 0px;
          }
        }
      }
    }

    & .t-body {
      & tr:nth-child(odd) {
        background-color: none;

        @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
          background-color: #f5f5f5;
        }
      }
      & .table-td {
        padding-bottom: 30px;
        font-weight: 500;
        size: 12px;
        line-height: 25px;
        padding-right: 20px;

        @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
          font-size: 14px;
          line-height: 25px;
          border: 2px solid #e0e0e0;
          padding-left: 20px;
          padding-top: 20px;
          padding-right: 0;
        }

        @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
          font-size: 16px;
          line-height: 25px;
        }
      }
    }
  }
`;
